import React from 'react';
import styles from './KPICard.module.css';
import KPICard from './index';

export interface KPISubRowItem {
  label: string;
  value: string;
  rawValue?: number;
}

export interface KPICardItem {
  value: string | number;
  rawValue?: number;
  title: string;
  accentColor: string;
  iconType?: 'federation' | 'queries' | 'engaged' | 'transfer';
  tooltip?: string;
  subRow?: KPISubRowItem[];
}

interface KPICardContainerProps {
  cards: KPICardItem[];
  isLoading?: boolean;
}

const KPICardContainer: React.FC<KPICardContainerProps> = ({ cards, isLoading }) => {
  return (
    <div className={styles.container}>
      {cards.map((card, index) => (
        <KPICard key={index} {...card} isLoading={isLoading} />
      ))}
    </div>
  );
};

export default KPICardContainer;
